import React, {useEffect, useRef, useState} from 'react';
import styles from './rating.module.css'
import { ReactComponent as Heart } from '../../assets/img/heart.svg'
import { ReactComponent as SharingButton } from '../../assets/img/sharing.svg'
import {useDispatch} from "react-redux";
import {addLike, addShareCount} from "../News/newsSlice";
import {addActionLike, addActionShareCount} from "../Proposal/proposalSlice";


const Sharing = ({type, position, likes, sharing, id, isLiked}) => {
    const ref = useRef(null)
    const [click, setClick] = useState(likes)
    const [alreadyLiked, setAlreadyLiked] = useState(isLiked)
    const [sharingCount, setSharingCount] = useState(sharing)
    const link = window.location.href
    const dispatch = useDispatch()
    const handleAddLike = () => {
        type === 'news'
            ? dispatch(addLike(id))
            : dispatch(addActionLike(id))
        if (alreadyLiked) {
            setClick(click - 1)
            setAlreadyLiked(!alreadyLiked)
        } else {
            setClick(click + 1)
            setAlreadyLiked(!alreadyLiked)
        }
    }
    useEffect(() => {
        if ( position === 'current' && alreadyLiked) {
            ref.current.className = styles.currentLikes + ' ' + styles.active
        } else if(position === 'current' && !alreadyLiked){
            ref.current.className = styles.currentLikes
        } else if (position !=='current' && alreadyLiked){
            ref.current.className = styles.likes + ' ' +styles.sharingActive
        } else if (position !== 'current' && !alreadyLiked){
            ref.current.className = styles.likes + ' ' +styles.sharingPassive
        }

    },[isLiked, dispatch])

    const handleShare = () => {
        navigator.clipboard.writeText(link)
            .then(() => {
                window.showAlert({title: 'Скопировано в буфер обмена', type: 'success'})
            })
        type === 'news'
        ? dispatch(addShareCount(id))
        : dispatch(addActionShareCount(id))
        setSharingCount(sharingCount + 1)
    }

    return (
        <div onClick={event => event.preventDefault()} className={
            position !== 'current'
                ? styles.sharingContainer
                : styles.currentSharingContainer
        }>
            <span ref={ref} onClick={handleAddLike}><Heart/> { click }</span>
            <span onClick={handleShare}><SharingButton/> { sharingCount }</span>
        </div>
    );
};

export default Sharing;